import React from 'react';
import { default as EditProjectReportSliceModal } from '@rd-web-markets/shared/dist/reportPreview/modal/EditProjectReportSliceModal';
export default EditProjectReportSliceModal;